import React from "react";

export default function ProjectRequirement({ project }) {
  const {
    title,
    challenge,
    solution,
    impact
  } = project?.requirements || {};
  const renderSection = (sectionData) => (
    <div key={sectionData.title} className="grid grid-cols-6 gap-5 py-8 sm:py-10 border-b sm:grid-cols-12 border-purple/30 sm:gap-0">
      <div className="flex items-center col-span-6 gap-3 sm:gap-4 h-fit">
        <span className="flex items-center justify-center w-5 sm:w-6 rounded-full aspect-square bg-purple">
          <svg
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.48828 4.99609L1.49609 9.04297C1.35938 9.17969 1.14062 9.17969 1.03125 9.04297L0.484375 8.49609C0.347656 8.35938 0.347656 8.16797 0.484375 8.03125L3.71094 4.75L0.484375 1.49609C0.347656 1.35938 0.347656 1.14062 0.484375 1.03125L1.03125 0.484375C1.14062 0.347656 1.35938 0.347656 1.49609 0.484375L5.48828 4.53125C5.625 4.66797 5.625 4.85938 5.48828 4.99609Z"
              fill="white"
            />
          </svg>
        </span>
        <span className="font-semibold text-16 sm:text-18 text-white font-inter">
          {sectionData.title}
        </span>
      </div>
      <p className="col-span-6 text-gray-300 text-sm sm:text-base">
        {sectionData.description}
      </p>
    </div>
  );

  return (
    <section className="w-full pt-16 mb-16 md:pb-[153px]">
      <div className="w-full mx-auto theme-container px-4">
        <h2 className="text-34 sm:text-34 md:text-48 font-semibold text-white mb-8 sm:mb-[50px]  w-full xl:w-full">
          {title}
        </h2>

        {challenge && renderSection(challenge)}
        {solution && renderSection(solution)}
        {impact && renderSection(impact)}
      </div>
    </section>
  );
}
